// client/src/shared/components/BadgePopover/index.js
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Generic popover wrapper for badges/elements that should show a tooltip on hover/focus.
 * Automatically flips placement if there's not enough space in the viewport.
 */
const BadgePopover = ({ popoverId, header, body, placement = 'top', children }) => {
    const popover = (
        <Popover id={popoverId}>
            <Popover.Header>{header}</Popover.Header>
            <Popover.Body>{body}</Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement={placement}
            flip={true}
            overlay={popover}
        >
            {children}
        </OverlayTrigger>
    );
};

BadgePopover.propTypes = {
    popoverId: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    body: PropTypes.node.isRequired,
    placement: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default BadgePopover;
